/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
class SearchItemComponent extends Vue {
  @Prop({ required: true, type: [Object] })
  record: any;
  @Prop({ default: null, type: [String] })
  iconName: string;
  @Prop({ default: null, type: [String] })
  itemSubtext: string;

  /* mounted() {
    console.log('RECORD', this.record)
  } */

  get coIcon (): string {
    if (this.iconName !== null && this.iconName !== undefined) return this.iconName
    else {
      switch (this.record.type) {
        case 'superadmin':
          return 'stars'
        // case 'manager-admin' :
        case 'manager':
        case 'salesperson' :
          return 'icon-manager-admin'
        case 'maintenance_referent' :
        case 'vehicle_referent' :
          return 'icon-manager-basic'
        // case 'concierge':
        case 'caretaker':
        case 'independent_contractor':
        case 'internal_contractor':
        case 'external_provider':
        case 'external_provider_member':
          return 'icon-independent-contractor'
        case 'owner':
        case 'plus_user':
          return 'icon-owner'
        case 'tenant' :
        case 'customer' :
        case 'simple_user' :
          return 'icon-tenant'
        case '':
          return null
        default:
          return 'icon-tenant'
      }
    }
  }

  get coLabel (): string {
    let label: string = (this.record.firstname || '') + ' ' + (this.record.lastname || '')
    return label.trim().length === 0 ? this.record.text : label
  }

  get coSubLabel (): string {
    if (this.itemSubtext) return this.record[this.itemSubtext]
    return this.record.email ? this.record.email : null
  }
}

export default SearchItemComponent



// WEBPACK FOOTER //
// ./src/components/multi-select/search-item/index.ts